var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_503_6778)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D49EFF",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "url(#paint0_linear_503_6778)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_503_6778)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.5C10 12.9477 10.4477 12.5 11 12.5H29C29.5523 12.5 30 12.9477 30 13.5C30 14.0523 29.5523 14.5 29 14.5H11C10.4477 14.5 10 14.0523 10 13.5ZM29.2426 21.0857C29.6332 21.4762 29.6332 22.1094 29.2426 22.4999L25 26.7425C24.6095 27.1331 23.9763 27.1331 23.5858 26.7425L20.7573 23.9141C20.3668 23.5236 20.3668 22.8904 20.7573 22.4999C21.1479 22.1094 21.781 22.1094 22.1716 22.4999L24.2929 24.6212L27.8284 21.0857C28.2189 20.6952 28.8521 20.6952 29.2426 21.0857ZM11 16.5C10.4477 16.5 10 16.9477 10 17.5C10 18.0523 10.4477 18.5 11 18.5H29C29.5523 18.5 30 18.0523 30 17.5C30 16.9477 29.5523 16.5 29 16.5H11ZM10 21.5C10 20.9477 10.4477 20.5 11 20.5H16C16.5523 20.5 17 20.9477 17 21.5C17 22.0523 16.5523 22.5 16 22.5H11C10.4477 22.5 10 22.0523 10 21.5ZM11 24.5C10.4477 24.5 10 24.9477 10 25.5C10 26.0523 10.4477 26.5 11 26.5H16C16.5523 26.5 17 26.0523 17 25.5C17 24.9477 16.5523 24.5 16 24.5H11Z",
    fill: "#C74AE3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.5C10 12.9477 10.4477 12.5 11 12.5H29C29.5523 12.5 30 12.9477 30 13.5C30 14.0523 29.5523 14.5 29 14.5H11C10.4477 14.5 10 14.0523 10 13.5ZM29.2426 21.0857C29.6332 21.4762 29.6332 22.1094 29.2426 22.4999L25 26.7425C24.6095 27.1331 23.9763 27.1331 23.5858 26.7425L20.7573 23.9141C20.3668 23.5236 20.3668 22.8904 20.7573 22.4999C21.1479 22.1094 21.781 22.1094 22.1716 22.4999L24.2929 24.6212L27.8284 21.0857C28.2189 20.6952 28.8521 20.6952 29.2426 21.0857ZM11 16.5C10.4477 16.5 10 16.9477 10 17.5C10 18.0523 10.4477 18.5 11 18.5H29C29.5523 18.5 30 18.0523 30 17.5C30 16.9477 29.5523 16.5 29 16.5H11ZM10 21.5C10 20.9477 10.4477 20.5 11 20.5H16C16.5523 20.5 17 20.9477 17 21.5C17 22.0523 16.5523 22.5 16 22.5H11C10.4477 22.5 10 22.0523 10 21.5ZM11 24.5C10.4477 24.5 10 24.9477 10 25.5C10 26.0523 10.4477 26.5 11 26.5H16C16.5523 26.5 17 26.0523 17 25.5C17 24.9477 16.5523 24.5 16 24.5H11Z",
    fill: "#F7E4FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_503_6778",
    x: -15,
    y: -15,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_503_6778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_503_6778",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_503_6778"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_503_6778",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_503_6778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_6778",
    x1: 8.5,
    y1: 3.5,
    x2: 24.4026,
    y2: 34.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckList);
export default __webpack_public_path__ + "static/media/icon-check-list.15152f406ab287dcc1f68deda32fa9a4.svg";
export { ForwardRef as ReactComponent };